import { areaFormModel } from './areaFormModel';

const {
    formField: {
        name,
        description
    }
} = areaFormModel;

export const areaInitialValues = {
    [name.name]: '',
    [description.name]: ''
};
